














































































































































































































































import Vue from 'vue';
import moment from 'moment';
import {
  dateFormat,
  dateFormatYYYYMMDD,
  datePickerFormat,
  dateTransactionFormat,
  yearFormat,
} from '@/constants';
import { required } from 'vuelidate/lib/validators';
import { date, dateHelpers } from '@/validations';
import { DateFormat, FormValidation } from '@/mixins';
import { TransactionDetail } from './account-activity-child-components';
import { DatePicker } from '@/components/form-components';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { ExtendMixins } from '@/services';
import {
  MemberAccountResponseModel,
  PostedTransactionResponseModel,
  PostedTransactionsDatFilterParams,
  TableHeader,
} from '@/@types/member';
import { cloneDeep } from 'lodash';

interface Data {
  isLoading: boolean;
  tmp: string;
  search: string;
  pagination: any;
  selectedDateRangeFilter: number; // FILTER_30_DAYS
  selectedActivityTypeFilter: string;
  dateFilterParams: PostedTransactionsDatFilterParams;
  activityTypeFilterParams: any;
  filterDateFrom: string;
  filterDateTo: string;
  taxYear: number;
  datePickerOpen: boolean;
  showDateRangeMenu: boolean;
  customRangeStartDate: string;
  customRangeEndDate: string;
  dateFormat: string;
  dateFormatYYYYMMDD: string;
  dateTransactionFormat: string;
  FILTER_30_DAYS: number;
  FILTER_60_DAYS: number;
  FILTER_90_DAYS: number;
  FILTER_CURRENT_TAX_YEAR: number;
  FILTER_PRIOR_TAX_YEAR: number;
  FILTER_CUSTOM_DATE_RANGE: number;
  FILTER_ALL_ACTIVITY: number;
  FILTER_ACTIVITY_TYPE: number;
  ALL_ACTIVITY: string;
  filter: string;
}

export default ExtendMixins(
  DateFormat,
  FormValidation,
).extend({
  name: 'PostedTransactions',
  data(): Data {
    return {
      isLoading: false,
      tmp: '',
      search: '',
      pagination: {},
      selectedDateRangeFilter: 30, // FILTER_30_DAYS
      selectedActivityTypeFilter: 'all activity', // ALL_ACTIVITY
      dateFilterParams: {
        startDate: moment()
          .subtract(30, 'days')
          .format(dateFormat),
        endDate: moment()
          .add(5, 'days')
          .format(dateFormat),
      },
      activityTypeFilterParams: {},
      filterDateFrom: '',
      filterDateTo: '',
      taxYear: 2017,
      datePickerOpen: false,
      showDateRangeMenu: false,
      customRangeStartDate: '',
      customRangeEndDate: '',
      dateFormat,
      dateFormatYYYYMMDD,
      dateTransactionFormat,
      FILTER_30_DAYS: 30, // Intentional selection, used for logic
      FILTER_60_DAYS: 60, // Intentional selection, used for logic
      FILTER_90_DAYS: 90, // Intentional selection, used for logic
      FILTER_CURRENT_TAX_YEAR: 2000, // random constant
      FILTER_PRIOR_TAX_YEAR: 1999, // random constant
      FILTER_CUSTOM_DATE_RANGE: 99, // random constant
      FILTER_ALL_ACTIVITY: 9999, // random constant
      FILTER_ACTIVITY_TYPE: 2112, // random constant
      ALL_ACTIVITY: 'all activity',
      // THIS IS A BANDAID FOR VUEITFY UNTIL COLSPAN CAN BE SET MANUALLY
      // headers: [{}, {}, {}, {}, {}],
      filter: '',
    };
  },
  beforeMount() {
    this.showErrorModel = {
      customRangeStartDate: false,
      customRangeEndDate: false,
    };
  },
  validations: {
    customRangeStartDate: {
      required,
      date,
      afterAccountStartDate(value): boolean {
        return dateHelpers.sameOrAfterDate(this.account.startDate)(value);
      },
      startDateInPast(value): boolean {
        return dateHelpers.sameOrBeforeDate(moment().format(dateFormat))(value);
      },
      beforeEndDate(value): boolean {
        return dateHelpers.sameOrBeforeDate(
          moment(this.customRangeEndDate, dateFormat).format(dateFormat),
        )(value);
      },
    },
    customRangeEndDate: {
      required,
      date,
      afterStartDate(value): boolean {
        return dateHelpers.sameOrAfterDate(
          moment(this.customRangeStartDate, dateFormat).format(dateFormat),
        )(value);
      },
      endDateInPast(value): boolean {
        return dateHelpers.sameOrBeforeDate(moment().format(dateFormat))(value);
      },
    },
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    startDate(): string {
      return this.account.startDate;
    },
    postedContributionsYTD(): number {
      // See REST-009 BR-2.31
      const contributions = this.$store.getters.accountDetail.contributions;
      return contributions ? contributions : 0;
    },
    transactions(): PostedTransactionResponseModel[] {
      return this.$store.getters.postedTransactions;
    },
    filteredTransactions(): PostedTransactionResponseModel[] {
      if (!this.search) {
        return this.transactions;
      }

      const searchString = String(this.search).toLowerCase();
      return this.transactions.filter(
        (x) =>
          String(x.description)
            .toLowerCase()
            .includes(searchString) ||
          this.$options.filters
            .currency(x.paymentAmount)
            .includes(searchString),
      );
    },

    // VALIDATIONS
    customRangeStartDateErrors(): string[] {
      const formField = 'customRangeStartDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-activity_form-error_custom-range-start-date_invalid-format',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-activity_form-error_custom-range-start-date_before-account-start-date',
          'afterAccountStartDate',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-activity_form-error_custom-range-start-date_invalid-date-future',
          'startDateInPast',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-activity_form-error_custom-range-start-date_after-end-date',
          'beforeEndDate',
        ),
      ]);
    },
    customRangeEndDateErrors(): string[] {
      const formField = 'customRangeEndDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-activity_form-error_custom-range-end-date_invalid-format',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-activity_form-error_custom-range-end-date_before-start-date',
          'afterStartDate',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-activity_form-error_custom-range-end-date_invalid-date-future',
          'endDateInPast',
        ),
      ]);
    },

    selectedDateFilterName(): string {
      switch (this.selectedDateRangeFilter) {
        case this.FILTER_30_DAYS:
          return this.$options.filters.t('account-activity_label_last-30-days');
        case this.FILTER_60_DAYS:
          return this.$options.filters.t('account-activity_label_last-60-days');
        case this.FILTER_90_DAYS:
          return this.$options.filters.t('account-activity_label_last-90-days');
        case this.FILTER_CURRENT_TAX_YEAR:
          return this.$options.filters.t(
            'account-activity_label_current-tax-year',
          );
        case this.FILTER_PRIOR_TAX_YEAR:
          return this.$options.filters.t(
            'account-activity_label_prior-tax-year',
          );
        case this.FILTER_CUSTOM_DATE_RANGE:
          return this.$options.filters.t(
            'account-activity_label_custom-date-range',
          );
        case this.FILTER_ALL_ACTIVITY:
          return this.$options.filters.t('account-activity_label_all-activity');
        default:
          return '';
      }
    },
    computedActivityTypes(): any[] {
      let types = this.transactions.map((x) => x.transactionType);
      // remove duplicates
      // tslint:disable-next-line
      types = types.filter((x, i) => types.indexOf(x) == i);
      types.sort();
      types.unshift(
        this.$options.filters.t('account-activity_label_all-activity'),
      );
      return types.map((x) => {
        return { text: x, value: x.toLowerCase() };
      });
    },
    isHSAAccount(): boolean {
      return this.account.productType === 'HSA';
    },
    headers(): TableHeader[] {
      return [
        {
          text: 'Date', // this.$options.filters!.t('report-adminfee-list-type'),
          value: 'postedDate',
          align: 'left',
        },
        {
          text: 'Description', // this.$options.filters!.t('report-adminfee-list-date'),
          value: 'description',
          align: 'left',
        },
        {
          text: 'Type', // this.$options.filters!.t('report-adminfee-list-number'),
          value: 'transactionType',
          align: 'left',
        },
        {
          text: 'Amount', // this.$options.filters!.t('report-adminfee-list-billed'),
          value: 'paymentAmount',
          align: 'right',
        },
        {
          text: '', // this.$options.filters!.t('report-adminfee-list-billed'),
          value: '',
          align: '',
        },
      ];
    },
  },
  methods: {
    deconstructCustomRangeStartDate(): void {
      this.customRangeStartDate = InputMaskTypes.date.deconstruct(
        this.customRangeStartDate,
      );
      this.validDateRange();
    },
    deconstructCustomRangeEndDate(): void {
      this.customRangeEndDate = InputMaskTypes.date.deconstruct(
        this.customRangeEndDate,
      );
      this.validDateRange();
    },
    fetchTransactionActivity(): void {
      const params = {};
      Object.assign(params, this.dateFilterParams);
      Object.assign(params, this.activityTypeFilterParams);
      this.$store.dispatch('setActivityTransactionFilterParams', params);
      this.$store
        .dispatch('getPostedTransactions', this.$route.params.id)
        .then(() => {
          this.isLoading = false;
        });
    },
    setDateFilter(filter): void {
      this.isLoading = true;
      this.showDateRangeMenu = false;

      // Reset activity filter: not in the use case, discussion 1/31/2018 w/Heidi & Patrick
      this.selectedActivityTypeFilter = this.ALL_ACTIVITY;
      this.activityTypeFilterParams = {};

      this.selectedDateRangeFilter = filter;
      if (filter !== this.FILTER_CUSTOM_DATE_RANGE) {
        this.customRangeStartDate = '';
        this.customRangeEndDate = '';
      }

      this.dateFilterParams = this.createDateFilterParams(filter);

      this.fetchTransactionActivity();
    },
    createDateFilterParams(filter): any {
      let params = {};
      this.filter = filter;

      switch (filter) {
        case this.FILTER_30_DAYS:
        case this.FILTER_60_DAYS:
        case this.FILTER_90_DAYS:
          params = {
            startDate: moment()
              .subtract(filter, 'days')
              .format(dateFormat),
            endDate: moment()
              .add(5, 'days')
              .format(dateFormat),
          };
          break;
        case this.FILTER_CURRENT_TAX_YEAR:
          params = {
            taxYear: moment().format(yearFormat),
          };
          break;
        case this.FILTER_PRIOR_TAX_YEAR:
          params = {
            taxYear: moment()
              .subtract(1, 'year')
              .format(yearFormat),
          };
          break;
        case this.FILTER_CUSTOM_DATE_RANGE:
          params = {
            startDate: this.customRangeStartDate,
            endDate: this.customRangeEndDate,
          };
          break;
        case this.FILTER_ALL_ACTIVITY:
          params = {};
          break;
        default:
          params = {
            startDate: moment()
              .subtract(this.FILTER_30_DAYS, 'days')
              .format(dateFormat),
            endDate: moment().format(dateFormat),
          };
      }

      return params;
    },
    setActivityTypeFilter(filter): void {
      this.isLoading = true;

      this.activityTypeFilterParams =
        filter.value === this.ALL_ACTIVITY
          ? {}
          : { transactionType: filter.text };

      this.fetchTransactionActivity();
    },
    allowedStartDates(startDate): boolean {
      return (
        moment(startDate, datePickerFormat).isSameOrAfter(
          moment(this.account.startDate, dateFormat),
          'day',
        ) && moment(startDate, datePickerFormat).isSameOrBefore(moment(), 'day')
      );
    },
    allowedEndDates(endDate): boolean {
      return (
        moment(endDate, datePickerFormat).isSameOrAfter(
          moment(this.customRangeStartDate, dateFormat),
          'day',
        ) && moment(endDate, datePickerFormat).isSameOrBefore(moment(), 'day')
      );
    },
    updateStartDate(startDate): void {
      this.customRangeStartDate = this.formatDate(startDate);
      this.triggerBlur('customRangeStartDate');
      this.updateHasChanged();
      this.validDateRange();
    },
    updateEndDate(endDate): void {
      this.customRangeEndDate = this.formatDate(endDate);
      this.triggerBlur('customRangeEndDate');
      this.updateHasChanged();
      this.validDateRange();
    },
    validDateRange(): void {
      if (
        !this.$v.customRangeStartDate.$invalid &&
        !this.$v.customRangeEndDate.$invalid
      ) {
        this.showDateRangeMenu = false;
        this.setDateFilter(this.FILTER_CUSTOM_DATE_RANGE);
      }
    },
    isExpandible(item): boolean {
      return (
        item.transactionType === 'Payment' ||
        item.transactionType === 'Reimbursement'
      );
    },
  },
  components: {
    TransactionDetail,
    DatePicker,
  },
});
